import React, {useRef, useEffect} from "react";

import { 
    Layout, 
    Typography, 
    Input,  
    Row, 
    Col
} from 'antd';
import "./index.css"
import useWindowDimensions from "../../components/useWindowDemision";
import { ArrowLeftOutlined } from '@ant-design/icons';
import Cart from '../../assets/images/Cart.png';
import image_default from '../../assets/images/image_default.png';
import btn_close from '../../assets/images/btn_close.png';
import BarcodeScan from '../../components/scanBarcodes';
import ViewLogHistory from './history';
import ContentInputCateGory from './category';
import ContentScans from './contentScan';
import 'react-multi-carousel/lib/styles.css';

const { Paragraph } = Typography;

const AddProductPageView = ({
    values,
    setBarcode,
    barcodeReScan,
    setBarcodeReScan,
    isScans,
    isLogHistory,
    setIsScans,
    onClickGoBack, 
    showDetailProduct, 
    deleteItemProduct,
    submitListProduct,
    isScrollTop,
    onClickBtnScan,
    onClickBtnInput,
    onClickBtnLog,
    allProduct,
    isInput,
    setIsInput,
    setActiveKey,
    handleScroll,
    setIndexSlice,
    dataImg,
    setDataImg,
    localStorageParamUrl,
    onSearchCategory,
    onClickItemProduct,
    dataSelectCategory,
    ClickBtnInPutAddProductToList,
    isAddCateToList,
    isAddScanToList,
    setIsAddScanToList,
    clickBtnScanAddPrdToList,
    querys,
    searched,
    dataDfQuery,
    dataSelectScanned,
    searChLogHistory,
    setIsLogHistory,
    dataHistory,
    onChangeDateFrom,
    onChangeDateTo,
    dateNow,
    dataImgHistory,
    showDetailPrdHistory,
    dateFrom,
    deleteHistory,
    setCountTooltipAdd,
    setCountTooltipMinus
}) => {

    const { Header, Footer, Content } = Layout;
    const {width, height } = useWindowDimensions();
    const messageRef = useRef();

    const styleTitleTop ={
        display: 'flex',
        height: 50, width: '100%', 
        justifyContent:'center',
    }
    const styleHeader={
        display: 'flex',
        backgroundColor: 'transparent',
        justifyContent: 'center', 
        alignItems: 'center', 
        flexDirection:'column'
    }
    const styleContentBody={
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }
    const styleFooter={
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center', 
        position: 'fixed',
        left: 0,
        bottom: 2,
        width: '100%',
        maxWidth:480,
        marginBottom:0, 
        height:35,
    }
    const container={
        height: height, 
    }
    const styleScanBtn={
        flexDirection:'row', 
        display:'flex', 
        maxWidth: 480,
        width: width, 
        justifyContent:'center', 
        alignItems: 'center'
    }
    const styleChildBody={
        display: 'flex', 
        flexDirection: 'column',
        width: '100%',
        height: '100%', 
        justifyContent: 'center',
        alignItems: 'center'
    }
    const styleBtnClose={
        position:'absolute', 
        top:0, 
        left:0, 
        width:40, 
        height:40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding:12
    }
    const styleBoxContainer={
        display:'flex',
        margin:5, 
        flexDirection: 'column',
        marginBottom:10,
        marginTop:5
    }
    const styleImgDelete={
        width:22, 
        height:22, 
        borderRadius:11,
        backgroundColor:'#CCCCCC', 
        marginBottom:1, 
        marginRight:-6,
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center'
    }
    const styleContainerItem={
        alignItems: 'center', 
        justifyContent: 'center', 
        display: 'flex', 
        flexDirection: 'column'
    }
    const inPutTextFilter={
        position: "absolute", 
        top:10,
        width: 297, 
        height:30, 
        backgroundColor: '#E6E6E6',
        borderRadius: 5, 
        marginLeft:20
    }
    const styleContentListVer={
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
    }
    const styleChildContentList={
        marginTop: 40, 
        overflowX: 'hidden',
        height: '100%', 
        width:'100%',
        paddingBottom: 50
    }
    const styleHeaderScans ={
        padding:0,
        width:'100%',
        maxWidth: 480,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '20%',
        marginTop:-10,
    }
    
    useEffect(() => {
        if (messageRef.current) {
            messageRef.current.scrollTo(0, 0);
        }
    },[isScrollTop]);

    /* Top component */
    const ContentHeader =()=>{
        return(
            <>
                <div style={{...styleTitleTop, position: "absolute", top:10}}>
                    <h6 className="text-title-top"> 対象食品の追加 </h6>
                </div>
                <div onClick={onClickGoBack}>
                    <ArrowLeftOutlined className ="icon-goBack"/> 
                </div>
                <div style={{width: width, marginBottom:8}}>
                    <h6 className="text-sub-title-top">栄養バランスの対象食品を追加するこができます</h6>
                </div>
            </>
        );
    };

    /* Button scan component */
    const ContentButtonHeader =()=>{
        return(
            <div style={{
                marginTop:0,
                flexDirection:'column', 
                display:'flex', 
            }}>  
                <div style={styleScanBtn}>
                    <div 
                        style={{flexDirection: "column"}}
                        onClick={onClickBtnScan}
                        className ="Button-Scan" >
                        <h6 className ="text-btn-scan">商品バーコード</h6>
                        <h6 className ="text-btn-scan1">スキャン</h6>
                    </div>
                    <div 
                        onClick={onClickBtnInput}
                        className ="Button-Input">
                        <h6 className ="text-btn1">カテゴリから探す</h6>
                    </div>
                </div>
                <div style={{...styleScanBtn, marginTop:10}}>
                    <div 
                        style={{flexDirection: "column"}}
                        onClick={onClickBtnLog}
                        className ="Button-Input-log" >
                        <h6 className ="text-btn-scan">追加履歴を見る</h6>
                    </div>
                    <div style={{width:159, height:55, marginLeft:5}}></div>
                </div>
            </div>
        );
    };

    /* Body component list verical */
    const contentBodyListVertical =(item, index)=>{

        if(!item.jan_code) return;

        return (
            <div 
                style={styleBoxContainer}
                className="box" 
                key={index} 
            >
                <Row style={{
                    width:'100%', 
                    height:22, 
                    display: 'flex'
                }}>
                    <Col span={12} >
                        <div style={{ position:'absolute', top:8, left:3.5 }}>
                            <h6 style={{color:'#16a5a5', fontSize:14, fontWeight:'bold'}} >{ "x" + (item?.count ? item.count : 1)}</h6>
                        </div>
                    </Col>
                    <Col span={12} style={{justifyContent:'flex-end', alignItems: 'flex-end', display: 'flex'}}>
                        <div onClick={()=> deleteItemProduct(item, null)} style={styleImgDelete}>
                            <img src={btn_close} width="50%" height="50%" alt="imageDeletePrd"/>
                        </div>
                    </Col>
                </Row>
                <div >
                
                    <div style={styleContainerItem}
                        onClick={()=>showDetailProduct(item, index)}>
                        <Paragraph 
                            className="text-title-scanned" 
                            ellipsis={true} 
                            style={{marginTop:-5}}> 
                            {item.jan_code? item.jan_code : ''}
                        </Paragraph>
                        <img 
                            src={
                                dataImg.filter((item_url)=> item_url.item_code === item.jan_code)[0]? 
                                dataImg.filter((item_url)=> item_url.item_code === item.jan_code)[0]?.image_url 
                                : item.image_url? item.image_url :image_default
                            }
                            width="100" height="100" 
                            alt="imagePrds"
                        />
                        <Paragraph 
                            className="text-name-prd-btn" 
                            ellipsis={true}>
                            {item?.product_name? item?.product_name 
                                : item.food_name? item.food_name : '' } 
                        </Paragraph>

                        <div className="packing-spec"> 
                            <Paragraph 
                                className="text-packing-spec-bottom" 
                                ellipsis={true}>
                                { Math.round((item.packing_spec*100) * 100) / 100  + "グラム"}
                            </Paragraph>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const headerDf =()=>{
        return(
            <Header style={{...styleHeader, height:225}}>
                <ContentHeader/>
                <ContentButtonHeader/>
            </Header>
        );
    };

    const headerScan =()=>{
        return(
            <Header style={styleHeaderScans}>
                <BarcodeScan 
                    setBarcode={setBarcode}
                    barcodeReScan={barcodeReScan}
                    setBarcodeReScan={setBarcodeReScan}
                />
                <div 
                    onClick={()=> {
                        setIsScans(false);
                        setBarcode('');
                        setIsInput(false);

                        const valueContent = Array.from(new Set(values?.dataValue));
                        if(valueContent.length >0){
                            setIsAddScanToList(true);
                        }else{
                            setIsAddScanToList(false);
                        };
                    }}
                    style={styleBtnClose}>
                    <img src={btn_close} width="100%" height="100%" alt="imageBtnCls"/>
                </div>
            </Header>
        );
    };

    const headerInput =()=>{
        return(
            <Header style={{...styleHeader,  height:'6%'}}>
                <Input 
                    defaultValue={dataDfQuery}
                    placeholder="食品名称" 
                    onChange={(e)=>onSearchCategory(e.target.value)} 
                    style={inPutTextFilter}
                />
                <div 
                    onClick={()=> {
                        setIsScans(false);
                        setBarcode('');
                        setIsInput(false);
                    }}>
                    <ArrowLeftOutlined className ="icon-goBack"/>
                </div>
            </Header>
        );
    };

    const contentDf=()=>{
        return(
            <Content style={styleContentBody}>
                <h6 className ="text-title"> 追加した食品 </h6> 
                <div style={styleChildBody}>
                    <img src={Cart} width="60" height="60" alt="images"/>
                    <h6 className="text-title-cart">追加されていません</h6> 
                </div>
            </Content>
        );
    };

    const contentItemAddListVer =()=>{
        
        const valueContent = Array.from(new Set(values?.dataValue)).filter((item=> item.isSubmit !== false));

        return(
            <Content style={{
                ...styleContentListVer, 
                alignItems:valueContent.length >1 ?'center' :'flex-start',
            }}>
                <h6 className ="text-title"> 追加した食品 </h6>

                    {valueContent.length < 3?
                        <div style={{
                            paddingTop:40, 
                            display: 'flex', 
                            flexDirection:'row', 
                            marginLeft: valueContent.length ===1? 15: null
                        }}>
                            {
                                valueContent
                                .filter((item, index)=> item.isSubmit !== false)
                                .map((item, index)=> contentBodyListVertical(item, index))
                            }
                            
                        </div> :
                        <div 
                            className="list" 
                            ref={messageRef} 
                            style={styleChildContentList} 
                        >
                            <div className={'board'}>
                                {
                                    valueContent
                                    .filter((item, index)=> item.isSubmit !== false)
                                    .map((item, index)=> contentBodyListVertical(item, index))
                                }
                            </div> 
                        </div> 
                    }
            </Content>
        );
    };

    const footerScan =()=>{
        return(
            <Footer style={styleFooter}> 
                <div 
                    onClick={clickBtnScanAddPrdToList}
                    className ="btn-bottom-scan">
                    <h6 className ="text-titless ">スキャン完了</h6>
                </div>
            </Footer>
        );
    };

    const footerInputCategory =()=>{
        return(
            <Footer style={styleFooter}>
                <div 
                    onClick={(dataSelectCategory?.length > 0)? ClickBtnInPutAddProductToList :null}
                    className = {(dataSelectCategory?.length > 0)? "btn-update" :"btn-bottom"} >
                    <h6 className ="text-titless ">追加</h6>
                </div>
            </Footer>
        );
    };

    const footerSubmit =()=>{
        return(
            <Footer style={styleFooter}>
                <div 
                    onClick={(values?.dataValue?.length > 0)? submitListProduct :null}
                    className = {(values?.dataValue?.length > 0)? "btn-update" :"btn-bottom"} >
                    <h6 className ="text-titless ">登録 </h6>
                </div>
            </Footer>
        );
    };

    return ( 
        <Layout className="add-family-page" style={container}>
            { isLogHistory? 
                <ViewLogHistory
                    dataHistory={dataHistory}
                    dataImgHistory={dataImgHistory}
                    dateFrom={dateFrom}
                    deleteHistory={deleteHistory}
                    showDetailPrdHistory={showDetailPrdHistory}
                    setIsLogHistory={setIsLogHistory}
                    onChangeDateFrom={onChangeDateFrom}
                    onChangeDateTo={onChangeDateTo}
                    dateNow={dateNow}
                    searChLogHistory={searChLogHistory}
                />: 
                <>
                    <>
                        { isScans? headerScan()
                            :(isInput && allProduct?.length > 0)? headerInput()
                            :headerDf() 
                        }
                    </>

                    <>
                        { isScans? 
                            <ContentScans
                                dataSelectScanned={dataSelectScanned}
                                setCountTooltipMinus={setCountTooltipMinus}
                                setCountTooltipAdd={setCountTooltipAdd}
                                deleteItemProduct={deleteItemProduct}
                            />
                            :(isScans === false && isAddScanToList && isInput === false)? 
                            contentItemAddListVer() : !isInput? contentDf() : null
                        }
                    </>

                    <>
                        { (isInput && allProduct?.length > 0)? 
                            <ContentInputCateGory
                                handleScroll={handleScroll}
                                searched={searched}
                                dataImg={dataImg}
                                onClickItemProduct={onClickItemProduct}
                                localStorageParamUrl={localStorageParamUrl}
                                setDataImg={setDataImg}
                                querys={querys}
                                setIndexSlice={setIndexSlice}
                                setActiveKey={setActiveKey}
                                allProduct={allProduct}
                            />
                            : (isScans === false && isAddCateToList && isInput === false)? 
                            contentItemAddListVer():null 
                        }
                    </>

                    <>
                        { isScans? footerScan()
                            :(isInput && allProduct?.length > 0)? footerInputCategory()
                            :(isScans === false && isInput === false )? footerSubmit(): null
                        }
                    </>
                </>
            }
        </Layout>
    );
};

export default AddProductPageView;